import React from "react";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import EducationItemForm from "./EducationItemForm";
import { EDUCATION_ITEM_FORM_TEXTS } from "../shared/constants";
import { PageContentBox } from "../shared/styledComponents";

const CreateEducationItemPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageLayout showSearch={false}>
      <PageContentBox>
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" color="text.primary" mb={2}>
          {EDUCATION_ITEM_FORM_TEXTS.createPageTitle}
        </Typography>
        <EducationItemForm mode="create" />
      </PageContentBox>
    </PageLayout>
  );
};

export default CreateEducationItemPage;
